import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, User, ArrowLeft } from 'lucide-react';
import { authAPI } from '../services/api';
import './LoginPage.css';

const LoginPage = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authAPI.login(credentials.username, credentials.password);
      
      // Get user info
      const userInfo = await authAPI.getCurrentUser(response.access_token);
      
      // Store in localStorage
      localStorage.setItem('user', JSON.stringify({ 
        ...userInfo,
        token: response.access_token
      }));
      
      if (userInfo.role === 'admin') {
        navigate('/admin');
      } else if (userInfo.role === 'customer') {
        navigate('/customer');
      } else {
        navigate('/engineer');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.response?.data?.detail || 'Λάθος όνομα χρήστη ή κωδικός πρόσβασης');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <button 
          className="back-to-home"
          onClick={() => navigate('/')}
          aria-label="Επιστροφή στην αρχική"
        >
          <ArrowLeft size={20} />
          <span>Επιστροφή στην Αρχική</span>
        </button>

        <div className="login-header">
          <img 
            src="https://customer-assets.emergentagent.com/job_bb24eabe-6ef2-4d89-a7b7-511a398af039/artifacts/wea2b3ng_1000023447.png" 
            alt="Χατζηανδρέου Logo" 
            className="login-logo"
          />
          <h1>Είσοδος Συνεργάτη</h1>
          <p>Σύνδεση στο Διαχειριστικό Σύστημα</p>
        </div>

        <form className="login-form-page" onSubmit={handleSubmit}>
          <div className="form-field">
            <label htmlFor="username">
              <User size={18} aria-hidden="true" />
              Όνομα Χρήστη
            </label>
            <input
              type="text"
              id="username"
              name="username"
              value={credentials.username}
              onChange={handleChange}
              placeholder="Εισάγετε το όνομα χρήστη"
              required
              aria-required="true"
              autoComplete="username"
            />
          </div>

          <div className="form-field">
            <label htmlFor="password">
              <Lock size={18} aria-hidden="true" />
              Κωδικός Πρόσβασης
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              placeholder="Εισάγετε τον κωδικό"
              required
              aria-required="true"
              autoComplete="current-password"
            />
          </div>

          {error && (
            <div className="error-alert" role="alert">
              {error}
            </div>
          )}

          <button type="submit" className="login-submit-btn" disabled={loading}>
            {loading ? 'Σύνδεση...' : 'Σύνδεση'}
          </button>
        </form>

        <div className="login-test-info" style={{ display: 'none' }}>
          <p><strong>Για δοκιμή:</strong></p>
          <p>Username: <code>XATZI123</code></p>
          <p>Password: <code>XATZ123</code></p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
